export default __webpack_public_path__ + "881914884155727ee8a7d1c31bba6fb9.gif";